import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'cruscotto',
  titolo: 'Il cruscotto, il menu e le notifiche',
  gruppo: 'Per iniziare',
  permesso: null,
  aCheServe: 'Il Cruscotto è la prima pagina dopo l’accesso: dice che cosa ti aspetta oggi. Il menu a '
    + 'sinistra porta alle pagine che ti servono.',
  parti: [
    {
      titolo: 'Che cosa trovi nel Cruscotto',
      testo: [
        'I riquadri compaiono solo se ti riguardano. Il logo CIDIS in alto riporta sempre qui.',
      ],
      passi: [
        '«Da leggere»: le ultime notifiche. «Tutte le notifiche» apre l’elenco.',
        '«Da sistemare»: schede da completare, firme di terzi da completare, i tuoi interventi in bozza. Ogni '
          + 'voce porta al suo elenco.',
        '«Ricontatti dei prossimi sette giorni»: gli appuntamenti che segui tu, compresi quelli rimasti indietro.',
        '«Le tue prossime mediazioni», se sei mediatrice o mediatore.',
        '«Oggi in sede», se hai l’agenda: se la sede è aperta e con quale orario, chi è in turno, quanti impegni ci '
          + 'sono. «Agenda del giorno» apre l’agenda.',
        '«Incarichi»: i tuoi ruoli, dove valgono e fino a quando.',
      ],
      immagine: {
        file: 'cruscotto.webp', larghezza: 1200, altezza: 760,
        descrizione: 'Il Cruscotto di un operatore interno, con i riquadri Da leggere, Da sistemare, '
          + 'Ricontatti e Incarichi.',
      },
    },
    {
      titolo: 'Il menu',
      testo: [
        'A sinistra il menu è diviso in gruppi: «Lavoro», «Rete», «Comunicazione», «Controllo». Ognuno vede '
          + 'solo le voci che i suoi incarichi consentono. In fondo, sotto «Aiuto», ci sono questa Guida e le '
          + 'Novità.',
        'Sul telefono e sui tablet in verticale il menu è nascosto: si apre con il comando in alto a sinistra.',
      ],
    },
    {
      titolo: 'Le notifiche',
      passi: [
        'Il numero accanto a «Notifiche» dice quante non hai letto.',
        'Apri «Notifiche»: alcune hanno sotto un collegamento, per esempio «Apri la scheda».',
        '«Segna tutte come lette» azzera il numero.',
      ],
      nota: 'Le notifiche non arrivano per email e non riportano mai il motivo di un ricontatto: lo leggi nella scheda.',
    },
    {
      titolo: 'Gli avvisi sullo schermo',
      testo: [
        'Con il gestionale aperto, quando arriva un’email in una tua casella o una notifica nuova, compare un '
          + 'riquadro in basso a destra. Per un’email dice la casella, il mittente e l’oggetto; per una notifica il '
          + 'titolo. Un clic apre la conversazione o la notifica; la crocetta lo chiude. Si chiude da solo dopo otto '
          + 'secondi, ma non finché ci tieni sopra il puntatore. Ne restano al massimo tre: le altre novità si contano '
          + 'in «Altre … novità».',
        'Con il gestionale in secondo piano, dopo «Attiva le notifiche del computer» e il permesso del browser, '
          + 'arriva una notifica del computer. Dice solo «Nuova email in» e la casella, oppure «Nuovo avviso nel '
          + 'gestionale»: resta nel centro notifiche del computer, e chi passa davanti allo schermo non deve poter '
          + 'leggere mittenti né contenuti. Un clic riporta al gestionale. Arrivano per un’ora dall’ultima volta che '
          + 'hai usato il gestionale; al primo clic ripartono.',
        'Arrivano solo le email delle caselle che usi tu: la tua e quelle di gruppo o di progetto da cui scrivi. La '
          + 'posta dello storico e quella indesiderata non danno avvisi.',
        'Dal messenger arriva «Nuovo messaggio nel messenger» per le chat a due, al massimo uno ogni quarto d’ora per '
          + 'chat: vedi il capitolo «Messenger».',
      ],
      passi: [
        'Apri «Notifiche» e scendi a «Avvisi su questo computer».',
        '«Avvisi sullo schermo» accende o spegne i riquadri; «Notifiche del computer» le notifiche del sistema.',
        'Se compare «Attiva le notifiche del computer», premilo e rispondi «Consenti» al browser.',
      ],
      nota: 'Le scelte valgono per il computer che stai usando. Le notifiche del computer arrivano finché la sessione '
        + 'resta aperta: dopo un’ora senza usare il gestionale (4 ore sul computer ricordato) la sessione si chiude e '
        + 'smettono. Sul telefono gli '
        + 'avvisi arrivano con l’app CIDIS.',
    },
  ],
  avvertenze: [
    {
      quando: 'Non vedi una voce di menu o un comando che vede un collega.',
      cosaFare: 'Voci e comandi compaiono solo con l’incarico che li consente. Controlla i tuoi incarichi nel '
        + 'riquadro «Incarichi» e, se ti serve altro, chiedilo a chi assegna gli incarichi.',
    },
    {
      quando: '«Le notifiche del computer sono bloccate nel browser.»',
      cosaFare: 'Hai risposto «Blocca» al browser. Apri le impostazioni del sito (il lucchetto accanto all’indirizzo), '
        + 'consenti le notifiche e ricarica la pagina.',
    },
    {
      quando: '«Non c’è, oppure non rientra fra quello che puoi vedere con i tuoi incarichi.»',
      cosaFare: 'La cosa che cerchi non esiste o non rientra nei tuoi incarichi: il gestionale, apposta, non dice '
        + 'quale dei due. Controlla dove valgono i tuoi incarichi.',
    },
  ],
  vediAnche: ['accesso', 'percorsi-interventi', 'nuova-scheda', 'agenda'],
  parole: ['home', 'prima pagina', 'avvisi', 'incarichi', 'menu', 'navigazione', 'riquadro', 'notifiche del computer',
    'notifiche del browser', 'avviso email'],
}

export default capitolo
